import React, { memo, forwardRef } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';

const sanityConfig = {
  projectId: 'mv9l1nv2',
  dataset: 'production'
};

const GatsbyImageForwarded = forwardRef((props, ref) => <GatsbyImage {...props} ref={ref} />);

const SanityImage = memo(function SanityImage({
  image,
  width,
  height,
  alt,
  placeholder = 'blurred',
  fit = 'crop',
  loading = 'lazy',
  ...rest
}) {
  const imageData = getGatsbyImageData(image, { width, height, placeholder, fit }, sanityConfig);
  return <GatsbyImageForwarded {...rest} image={imageData} alt={alt} loading={loading} />;
});

export default SanityImage;
